import {Component, ChangeDetectionStrategy} from "@angular/core";

@Component({
    selector: "app-error-instance-not-found",
    templateUrl: "./error-instance-not-found.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorInstanceNotFoundComponent {}
